import { useState, useCallback, useEffect } from 'react';

export const useVolatilitySelectOptions = (
  setVolatilityOptions: any,
  key: string,
  initialItems?: any,
) => {
  const [selectedItems, setSelectedItems] = useState<any>(initialItems);

  const handleChange = useCallback(
    (options: any) => {
      if (!options) return;

      setSelectedItems(options);
      setVolatilityOptions((state: any) => ({ ...state, [key]: options }));
    },
    [setVolatilityOptions, key],
  );

  useEffect(() => {
    handleChange(initialItems);
  }, [initialItems, handleChange]);

  return {
    selectedItems,
    setSelectedItems,
    handleChange,
  };
};
